import React from "react";
import {
    Button,
    MenuItem,
    DropdownButton,
    Col,
    Glyphicon,
    Panel,
    PanelGroup,
    Row,
} from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import DeleteConfirmOverlay from "../../../../UI/DeleteConfirmOverlay";
import { quizQuestionAnswerCreate, quizQuestionAnswerDelete, quizQuestionCreate, quizQuestionDelete, quizQuestionUpdate } from "../../../../../../api/cp";
import StandardPollEditor from "../PollEditors/StandardPollEditor";
import OpenPollEditor from "../PollEditors/OpenPollEditor";
import RatingPollEditor from "../PollEditors/RatingPollEditor";

const quizPollTypes = [
    {
        id: 'standard',
        title: 'Стандартный',
        editor: (props) => <StandardPollEditor {...props} />
    },
    {
        id: 'open',
        title: 'Свободный выбор',
        editor: (props) => <OpenPollEditor {...props} />
    },
    {
        id: 'rating',
        title: 'Рейтинг',
        editor: (props) => <RatingPollEditor {...props} />
    },
];

const QuizPollEditor = ({ poll, quiz, onUpdate }) => {

    const savePoll = async (data) => {
        try {
            const _poll = await (poll?.id ? quizQuestionUpdate(poll.id, data) : quizQuestionCreate(quiz.id, data));
            onUpdate(_poll);
        } catch (e) {
            console.error(e);
        }
    }

    const setProperty = (key, value) => {
        onUpdate({ ...poll, [key]: value })
    }

    const saveProperty = async (name, value) => {
        return await savePoll({ [name]: value })
    }

    const savePropertyFile = async (name, file) => {
        const data = new FormData();
        data.append(name, file);
        return await savePoll(data);
    }

    const createAnswer = async (data = {}) => {
        const answer = await quizQuestionAnswerCreate(poll.id, { textRu: '', textEn: '', ...data });
        onUpdate({ ...poll, answer: [...poll.answer, answer] });
    }

    const deleteAnswer = async (answer) => {
        await quizQuestionAnswerDelete(answer.id);
        onUpdate({ ...poll, answer: poll.answer?.filter(({ id }) => id !== answer.id) });
    }

    return quizPollTypes.find(({ id }) => id === poll.type)?.editor({ poll, quiz, setProperty, savePoll, saveProperty, savePropertyFile, createAnswer, deleteAnswer });
}

export default ({ quiz, getProperty, setProperty, pollPanelIndex, setPollPanelIndex }) => {

    const createPoll = async (type = 'standard') => {

        const poll = await quizQuestionCreate(quiz.id, {
            textRu: 'Новый вопрос',
            textEn: 'New poll',
            type,
            private: 'standard' !== type,
        });

        setProperty('polls', [...getProperty('polls'), poll]);
        setPollPanelIndex(poll.id);
    }

    const deletePoll = async (poll) => {
        await quizQuestionDelete(poll.id);
        setProperty('polls', getProperty('polls').filter(({ id }) => id !== poll.id));
    }

    const onPollUpdate = (poll) => {
        let polls = getProperty('polls').slice();
        let index = polls.findIndex(({ id }) => id === poll.id);
        if (-1 === index) {
            polls.push(poll);
        } else {
            polls[index] = { ...polls[index], ...poll };
        }
        setProperty('polls', polls);
    }

    return <>
        <PanelGroup
            accordion
            activeKey={pollPanelIndex}
            onSelect={(index) => setPollPanelIndex(index)}
            id="quiz-polls-panels"
        >
            {getProperty('polls').map((poll) => (
                <Panel key={poll.id || 'new'} eventKey={poll.id}>
                    <PanelHeading>
                        <PanelTitle toggle>
                            <Row>
                                <Col xs={10} style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                    {poll.textRu}
                                    <span style={{ fontSize: '1.25rem' }}>({quizPollTypes.find(({ id }) => id === poll.type)?.title || ""})</span>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'right' }}>
                                    <DeleteConfirmOverlay title="Удалить вопрос?" onConfirm={() => deletePoll(poll)}>
                                        <Button bsStyle="danger" bsSize="small"><Glyphicon glyph="trash" /></Button>
                                    </DeleteConfirmOverlay>
                                </Col>
                            </Row>
                        </PanelTitle>
                    </PanelHeading>
                    <PanelBody collapsible>
                        <QuizPollEditor poll={poll} quiz={quiz} onUpdate={onPollUpdate} />
                    </PanelBody>
                </Panel>
            ))}
        </PanelGroup>
        <DropdownButton bsStyle="success" title="Добавить вопрос" id="addQuestionButton">
            {quizPollTypes.map(type => (<MenuItem key={type.id} onClick={() => createPoll(type.id)}>{type.title}</MenuItem>))}
        </DropdownButton>
    </>
}